import React from 'react'
import {Flex, FlexProps} from '@chakra-ui/react'

export default function PageNavigation({children, ...props}: FlexProps) {
  return (
    <Flex
      {...props}
      as="nav"
      align="center"
      bg="white"
      boxShadow="sm"
      h={12}
      justify="space-between"
      maxW="100vw"
      overflowX="auto"
      px={2}
      whiteSpace="nowrap"
    >
      {children}
    </Flex>
  )
}
